import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PlatformOwner {
  name: string;
  email: string;
  phone?: string;
  has_owner_account?: boolean;
  owner_account_active?: boolean;
}

export interface PlatformContacts {
  support_email: string;
  administration_email: string;
  sender_email: string;
  owners: PlatformOwner[];
  contact_phones: string[];
}

@Injectable({ providedIn: 'root' })
export class PlatformContactsService {
  private readonly http = inject(HttpClient);
  private readonly cache = signal<PlatformContacts | null>(null);
  readonly contacts = this.cache.asReadonly();

  load(): Observable<PlatformContacts> {
    const current = this.cache();
    if (current) return of(current);
    return this.http
      .get<PlatformContacts>(`${environment.apiUrl}/saas/platform-contacts`)
      .pipe(tap(d => this.cache.set(d)));
  }

  refresh(): Observable<PlatformContacts> {
    return this.http
      .get<PlatformContacts>(`${environment.apiUrl}/saas/platform-contacts`)
      .pipe(tap(d => this.cache.set(d)));
  }

  get snapshot(): PlatformContacts | null {
    return this.cache();
  }

  update(data: Partial<PlatformContacts>): Observable<PlatformContacts & { msg: string }> {
    return this.http
      .put<PlatformContacts & { msg: string }>(`${environment.apiUrl}/saas/admin/platform-contacts`, data)
      .pipe(tap(d => this.cache.set(d)));
  }
}
